var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.317,
    height: 11.193,
    viewBox: "0 0 11.317 11.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9146",
    "data-name": "Group 9146",
    transform: "translate(-1065 -560.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_324",
    "data-name": "Ellipse 324",
    transform: "translate(1065 561)",
    fill: "#151d2b",
    stroke: "#707070",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "add_circle_FILL0_wght400_GRAD0_opsz24",
    d: "M2.966,7.415H4.449V4.449H7.415V2.966H4.449V0H2.966V2.966H0V4.449H2.966ZM3.707,3.707Z",
    transform: "translate(1070.721 561.287) rotate(45)",
    fill: "#fff",
    stroke: "#151d2b",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDeleteIcon);
export default __webpack_public_path__ + "static/media/img-delete-icon.bcdd0dbf00aab42f5bf2b6a9794ee329.svg";
export { ForwardRef as ReactComponent };